import { Heading } from '@lendi-ui/typography';

import { BUSINESS_STRUCTURE } from '@funnels/constants';
import { CompanyEntityIndex, EmploymentEntityIndex } from '@funnels/types';
import { Divider, FunnelGridUnit } from '@funnels/ui-components/Common';
import {
  BusinessABN,
  BusinessAddress,
  BusinessName,
  BusinessOwnership,
  BusinessPhoneNumber,
  BusinessStructure,
  BusinessTrustType,
  CompanySelector,
  ForeignCompany,
} from '@funnels/ui-components/RelatedCompany';

interface BusinessDetailsProps extends CompanyEntityIndex, EmploymentEntityIndex {
  applicantId: string;
  isCurrentRole: boolean;
  isSelfEmployed: boolean;
  isForeignCompany: boolean;
  hasABN: boolean;
  businessStructure: BUSINESS_STRUCTURE;
}

export const BusinessDetails = (props: BusinessDetailsProps) => {
  const {
    companyIndex,
    employmentIndex,
    applicantId,
    isCurrentRole,
    isSelfEmployed,
    isForeignCompany,
    hasABN,
    businessStructure,
  } = props;

  return (
    <>
      <FunnelGridUnit mb="xl" mt="sm">
        <Divider />
      </FunnelGridUnit>
      <FunnelGridUnit mb="md">
        <Heading size="xs">{isSelfEmployed ? 'Business' : 'Employer'} details</Heading>
      </FunnelGridUnit>
      {isSelfEmployed && (
        <CompanySelector employmentIndex={employmentIndex} companyIndex={companyIndex} isInCustomerView />
      )}
      {companyIndex > -1 && (
        <>
          <FunnelGridUnit mb="md">
            <BusinessName
              companyIndex={companyIndex}
              label={isSelfEmployed ? 'Business name' : 'Employer name'}
              isDisabled={hasABN}
            />
          </FunnelGridUnit>
          <FunnelGridUnit mb="md">
            <BusinessABN companyIndex={companyIndex} employmentIndex={employmentIndex} isDisabled={isForeignCompany} />
            {!hasABN && <ForeignCompany companyIndex={companyIndex} isChecked={isForeignCompany} />}
          </FunnelGridUnit>
          {isSelfEmployed && (
            <FunnelGridUnit mb="md">
              <BusinessStructure
                companyIndex={companyIndex}
                employmentIndex={employmentIndex}
                isDisabled={hasABN}
                isOptional
              />
            </FunnelGridUnit>
          )}
          {businessStructure === BUSINESS_STRUCTURE.TRUST && isSelfEmployed && (
            <FunnelGridUnit mb="md">
              <BusinessTrustType companyIndex={companyIndex} isDisabled={hasABN} />
            </FunnelGridUnit>
          )}
          {isSelfEmployed && isCurrentRole && (
            <FunnelGridUnit mb="md">
              <BusinessOwnership
                companyIndex={companyIndex}
                applicantId={applicantId}
                isDisabled={businessStructure === BUSINESS_STRUCTURE.SOLE_TRADER}
                isOptional
              />
            </FunnelGridUnit>
          )}
          <FunnelGridUnit mb="md">
            <BusinessAddress companyIndex={companyIndex} isOptional />
          </FunnelGridUnit>
          <FunnelGridUnit mb="md">
            <BusinessPhoneNumber companyIndex={companyIndex} isOptional isForeignCompany={isForeignCompany} />
          </FunnelGridUnit>
        </>
      )}
    </>
  );
};
